import { deepMerge, deepClone } from './object';
import { decode } from './string';

/*
	Assume translation is in setup.static
	Always return string
	translation input is unchanged if not found.
*/

const translate = (setup, translation, translationProperty) => {
	let translatedStr = translation;

	// translation of object not simple static text.
	if (typeof translation === 'object') {
		translationProperty = translationProperty || 'text';
		translatedStr = translation[translationProperty];

		if (translation.localized && translation.localized[setup.language]) {
			Object.keys(translation.localized[setup.language]).forEach((item) => {
				if (item === translationProperty) {
					translatedStr = translation.localized[setup.language][item];
				}
			});
		}

		return decode(translatedStr);
	}

	if (typeof translation === 'string') {
		translationProperty = translationProperty || 'statics';
		const staticTranslation = setup[translationProperty][translation] && setup[translationProperty][translation].text;
		if (typeof staticTranslation === 'string') translatedStr = staticTranslation;
		if (typeof staticTranslation === 'object' && staticTranslation.text) translatedStr = staticTranslation.text;

		if (setup[translationProperty][translation] && setup[translationProperty][translation].localized && setup[translationProperty][translation].localized[setup.language]) {
			translatedStr = setup[translationProperty][translation].localized[setup.language].text || '';
		}
	}

	return decode(translatedStr);
};

const translateObjectData = (setup, objectData = {}) => {
	let returnObj = deepClone(objectData);
	if (Object.keys(setup.languages).length > 1 && returnObj?.localized?.[setup.language]) {
		returnObj = deepMerge(returnObj, returnObj.localized[setup.language]);
	}
	return returnObj;
};

const translateObjectDefaultData = (setup, objectData = {}) => {
	let returnObj = deepClone(objectData);
	if (Object.keys(setup.languages).length > 1 && returnObj[setup.language]) {
		returnObj = deepMerge(returnObj.default, returnObj[setup.language]);
	} else {
		returnObj = deepClone(returnObj.default);
	}
	return returnObj;
};

const prefix = (setup, str = '/') => {
	str = str.replace(/^\/*/, '');
	if (Object.keys(setup.languages).length > 1) {
		str = str.replace(`${setup.language}/`, '');
		return `/${setup.language}/${str}`;
	}
	return `/${str}`;
};

/*
	For testing purposes.

	var arr = [
		'/en_hello', // 'en_hello'
		'/en', // ''
		'/en/', // ''
		'/fr-ca/roller', // 'roller'
		'/fr-ca', // ''
		'/fr-ca/', // ''
		'/fr-ca-hello', // 'fr-ca-hello'
		'/fr-ca/hello', // 'hello'
		'/hello/uri', // 'hello/uri'
		'', // ''
		'/en/hello/ca-fr/uri/en', // 'hello/ca-fr/uri/en'
		'/ca-fr/hello/ca-fr/uri/en', // 'hello/ca-fr/uri/en'
	];
	arr.map(str => removeLanguagePrefix(str));
	arr.map(str => checkForLanguagePrefix(str));
	arr.map(str => returnLanguagePrefix(str));
*/

const checkForLanguagePrefix = (str) => /^[a-z]{2}(-[a-z]{2})?$/.test(str.split('/').filter((a) => !!a)[0]);

const removeLanguagePrefix = (str) => {
	const splitStr = str.split('/').filter((a) => !!a);
	if (splitStr.length > 0) splitStr[0] = splitStr[0].replace(/^[a-z]{2}(-[a-z]{2})?$/, '');
	return splitStr.filter((a) => !!a).join('/');
};

const returnLanguagePrefix = (str) => {
	const splitStr = str.split('/').filter((a) => !!a);
	if (splitStr.length > 0) {
		const matches = splitStr[0].match(/^[a-z]{2}(-[a-z]{2})?$/);
		if (matches && matches[0]) return matches[0];
	}
	return '';
};

export { translate, translateObjectData, translateObjectDefaultData, prefix, checkForLanguagePrefix, removeLanguagePrefix, returnLanguagePrefix };
